// game caches

export const COMPETITIONS_GAME_CACHE = 'competitions-game-cache';
export const COMPETITIONS_CACHE = 'competitions-cache';
export const COMPETITIONS_LEADERBOARD_CACHE = 'competitions-leaderboard-cache';
export const COLLECTION_METADATA_CACHE = 'collection_metadata_cache';
export const FANTASY_LEADERBOARD_CACHE = [COMPETITIONS_LEADERBOARD_CACHE];

// teams

export const COMPETITION_TEAMS_CACHE = 'competition-teams';
export const COMPETITION_TEAMS_BY_ID_CACHE = 'competition-teams-by-id';

export const COMPETITION_TEAM_QUERIES = [COMPETITION_TEAMS_CACHE, COMPETITION_TEAMS_BY_ID_CACHE];

// winners

export const COMPETITION_WINNERS_CACHE = 'competition-winners';
export const TEAM_COMPETITION_WINNERS_CACHE = 'team-competition-leaderboard';
export const FANTASY_WINNERS_CACHE = [
    COMPETITION_WINNERS_CACHE,
    COMPETITIONS_CACHE,
    TEAM_COMPETITION_WINNERS_CACHE,
    COMPETITIONS_LEADERBOARD_CACHE,
];
